module.exports = __webpack_public_path__ + "static/media/Phone.0d58c67d.png";